/* eslint-disable no-restricted-syntax */
import React, { useContext, useState } from 'react';
/* eslint-disable */
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  message,
  Radio,
  Row,
  Select,
  Spin,
} from 'antd';
/* eslint-disable */
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
/* eslint-disable */
import { useForm } from 'antd/es/form/Form';
/* eslint-disable */
import { DatePicker } from 'antd/es';
/* eslint-disable */
import formCol from '../../../../../utils/formCol';
import Paragraph from '../../../../../components/common/Paragraph';
import form from '../../../../../utils/form';
import tokens from '../../../../../utils/tokens';
import useParams from '../../../../params/useParams';
import paramType from '../../../../params/paramEndpoints';
import FatcaModal from './FatcaModal';
import TaxResidenceModal from './TaxResidenceModal';
import FundsOriginDeclarationModal from './FundsOriginDeclarationModal';
import { EnrollmentContext } from '../../../../../providers/EnrollmentContextProvider';
import IdentificationType from '../../../../../enums/identificationType';
import { rutValidator } from '../../../../../utils/validators';
import InputRut from '../../../../../components/form/inputs/InputRut';
import EnrollmentService from '../../../EnrollmentService';
import enrollmentAction from '../../../../../providers/EnrollmentContextProvider/enrollmentAction';
import FileSelect from '../../../../../components/form/upload/SingleUpload';
import file from '../../../../../utils/file';
import AloneCol from '../../../../../components/common/AloneCol';
import DrawerQualifiedProfile from '../../../../EnrollmentLegal/components/Wizard/Steps/ComplementaryInfo/components/DrawerQualifiedProfile';

const ComplementaryInfoStep = ({ onFinish }) => {
  const [isLoading, setLoading] = useState(false);
  const { enrollmentForm, currentStepIndex, dispatch, enrollmentId, enrollment } = useContext(
    EnrollmentContext
  );
  const initialValues = enrollmentForm[`step${currentStepIndex}`];
  const [instructionTypes] = useParams(paramType.INSTRUCTION_TYPES);
  const [informationDestinations] = useParams(paramType.INFORMATION_DESTINATIONS);
  const [countries, areCountriesLoading] = useParams(paramType.COUNTRIES);
  const [sexes, areSexesLoading] = useParams(paramType.SEXES);
  const [visible, setVisible] = useState(false);
  const [vantrustRelations, areVantrustRelationsLoading] = useParams(paramType.VANTRUST_RELATIONS);
  const [showsVantrustRelation, setShowsVantrustRelation] = useState(
    initialValues?.hasVantrustRelation
  );
  const [qualifiedInvestor, setQualifiedInvestor] = useState(false);
  const [savedQualifiedInvestor, setSavedQualifiedInvestor] = useState(false);
  const [showValidationMessages, setShowValidationMessages] = useState(false);
  const [qualifiedInfoForm] = Form.useForm();
  const [showsOtherVantrustRelation, setShowsOtherVantrustRelation] = useState(
    initialValues?.vantrustRelation === '(7) OTRAS-PERSONAS'
  );
  const [showsOtherInfoDestination, setShowsOtherInfoDestination] = useState(
    initialValues?.clientInfoDestinyId === 'OTRO'
  );
  const [powerFileLists, setPowerFileLists] = useState(initialValues?.powerFileLists || []);
  const [showsNif, setShowsNif] = useState(initialValues?.isUsPerson);
  const [showsTaxResidences, setShowsTaxResidences] = useState(
    initialValues?.hasForeignTaxResidence
  );
  const [empoweredToSignIdTypes, setEmpoweredToSignIdTypes] = useState({});
  const [complementaryForm] = useForm();

  const onChangeRadioQualified = (e) => {
    if (e.target.value) {
      setVisible(true);
      setShowValidationMessages(false);
      setQualifiedInvestor(true);
    } else {
      setQualifiedInvestor(false);
      setShowValidationMessages(false);
    }
  };

  const handleUsPersonChange = (event) => {
    setShowsNif(event.target.value === 'true');
  };

  const handleHasTaxResidenceChange = (event) => {
    setShowsTaxResidences(event.target.value === 'true');
  };

  const handleSubmit = async (values) => {
    const empoweredToSign = [];

    if (qualifiedInvestor && !savedQualifiedInvestor) {
      setShowValidationMessages(true);
      setVisible(true);
      return;
    }

    if (values.empoweredToSign) {
      for (
        let empoweredIndex = 0;
        empoweredIndex < values.empoweredToSign.length;
        empoweredIndex += 1
      ) {
        const theEmpowered = values.empoweredToSign[empoweredIndex];

        empoweredToSign.push({
          ...theEmpowered,
          power: undefined,
          emailValidation: undefined,
          documents: [
            {
              typeKey: file.types.EMPOWERED_TO_SIGN_POWER,
              base64: await file.toBase64(theEmpowered.power),
              filename: theEmpowered?.power.name,
            },
          ],
        });
      }
    }

    const payload = {
      ...values,
      clientInfoDestinyId: Number(values.clientInfoDestinyId),
      nif: Number(values.nif),
      hasVantrustRelation: undefined,
      acceptsFundsOriginTerms: undefined,
      hasForeignTaxResidences: values.hasForeignTaxResidences,
      foreignTaxResidences: values.foreignTaxResidences?.map((residence) => ({
        ...residence,
      })),
      empoweredToSign,
      otherVantrustRelation: showsOtherVantrustRelation ? values.otherVantrustRelation : undefined,

      person: values.person &&
        enrollment.person && {
          ...enrollment.person,
          ...values.person,
          nif: values.person?.nif ? Number(values.person.nif) : undefined,
        },
    };

    setLoading(true);

    EnrollmentService.updateEnrollment(payload, enrollmentId)
      .then(() => {
        dispatch({
          type: enrollmentAction.SET_STEP_DATA,
          payload: { ...values, powerFileLists },
        });
        onFinish();
      })
      .catch(() => {
        message.error('Error inesperado. Por favor, intente nuevamente.');
      })
      .finally(() => setLoading(false));
  };

  const handleInfoDestinationSelect = (event) => {
    setShowsOtherInfoDestination(event.target.value === 'OTRO');
  };

  const handleEmpoweredToSignIdTypeChange = (index) => (event) => {
    complementaryForm.setFieldsValue({
      empoweredToSign: complementaryForm
        .getFieldValue('empoweredToSign')
        .map((person, personIndex) => ({
          ...person,
          identification: personIndex === index ? undefined : person?.identification,
        })),
    });
    setEmpoweredToSignIdTypes((prevValue) => ({
      ...prevValue,
      [index]: event.target.value,
    }));
  };

  const handleVantrustRelationSelect = (relation) => {
    setShowsOtherVantrustRelation(relation === '(7) OTRAS-PERSONAS');
  };

  const handleHasVantrustRelationChange = (event) => {
    const nowShowsVantrustRelations = event.target.value === 'true';
    setShowsVantrustRelation(nowShowsVantrustRelations);
    if (!nowShowsVantrustRelations) {
      setShowsOtherVantrustRelation(false);
    }
    complementaryForm.setFieldsValue({
      vantrustRelation: undefined,
      otherVantrustRelation: undefined,
    });
  };

  const handlePowerFileListChange = (index) => (fileList) => {
    setPowerFileLists((prevValue) => {
      const updatedList = [...prevValue];
      updatedList[index] = fileList;
      return updatedList;
    });
  };

  const getEmpoweredToSignIdLabel = (index) => {
    switch (empoweredToSignIdTypes[index]) {
      case IdentificationType.RUT:
        return 'RUT';
      case IdentificationType.PASAPORTE:
        return 'Pasaporte';
      default:
        return 'RUT/Pasaporte';
    }
  };

  const handleEmpoweredToSignAdd = (index) => {
    setPowerFileLists((prevLists) => {
      const updatedList = [...prevLists];
      if (updatedList.length - 1 < index) {
        updatedList.push();
      }
      return updatedList;
    });
  };

  const handleEmpoweredToSignRemove = (index) => {
    setPowerFileLists((prevLists) => {
      const updatedList = [...prevLists];
      if (updatedList.length > index) {
        updatedList.splice(index, 1);
      }
      return updatedList;
    });
  };

  const preventCopyPasteAndSpaces = (e) => {
    if (e.type === 'paste') {
      e.preventDefault();
      return;
    }

    // Prevent spaces
    const value = e.target.value;
    if (/\s/g.test(value)) {
      e.target.value = value.replace(/\s/g, '');
    }
  };

  return (
    <Spin spinning={isLoading}>
      <Row justify="center">
        <Col {...formCol.responsive}>
          <Form
            form={complementaryForm}
            onFinish={handleSubmit}
            layout="vertical"
            validateMessages={form.validateMessages}
            initialValues={initialValues}
          >
            <Row gutter={tokens.forms.horizontalGutterInPx}>
              <Col span={24}>
                <Form.Item
                  name="hasVantrustRelation"
                  label="¿Tienes alguna relación con VanTrust o sus empleados?"
                  onChange={handleHasVantrustRelationChange}
                  style={{ marginBottom: showsVantrustRelation ? '0.5rem' : undefined }}
                  rules={[{ required: true }]}
                >
                  <Radio.Group>
                    <Radio value>Sí</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
                {showsVantrustRelation && (
                  <Row gutter={tokens.forms.horizontalGutterInPx}>
                    <Col span={12}>
                      <Form.Item name="vantrustRelation" rules={[{ required: true }]}>
                        <Select
                          placeholder="Seleccione"
                          onChange={handleVantrustRelationSelect}
                          loading={areVantrustRelationsLoading}
                          allowClear
                        >
                          {vantrustRelations.map(({ id, name }) => (
                            <Select.Option key={id} value={id}>
                              {name}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    {showsOtherVantrustRelation && (
                      <Col span={12}>
                        <Form.Item name="otherVantrustRelation" rules={[{ required: true }]}>
                          <Input maxLength={30} placeholder="Especifique" />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                )}
              </Col>
              <Col span={24}>
                <Paragraph strong size="lg">
                  Comunicaciones y Órdenes
                </Paragraph>
                <Form.Item
                  name="instructionType"
                  label="Tipos de Instrucción"
                  rules={[{ required: true }]}
                >
                  <Radio.Group>
                    <Row>
                      {instructionTypes.map(({ id, name }) => (
                        <Col key={id} span={24}>
                          <Radio value={id}>{name}</Radio>
                        </Col>
                      ))}
                    </Row>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  name="clientInfoDestinyId"
                  label="Destino de Información al Cliente"
                  rules={[{ required: true }]}
                  style={{ marginBottom: showsOtherInfoDestination ? '0.5rem' : undefined }}
                >
                  <Radio.Group onChange={handleInfoDestinationSelect}>
                    <Row>
                      {informationDestinations.map(({ id, name }) => (
                        <Col key={id} span={24}>
                          <Radio value={id}>{name}</Radio>
                        </Col>
                      ))}
                    </Row>
                  </Radio.Group>
                </Form.Item>
                {showsOtherInfoDestination && (
                  <Form.Item name="otherClientInfoDestiny" rules={[{ required: true }]}>
                    <Input placeholder="especifique" />
                  </Form.Item>
                )}
                {/*
                : This is only for SPOT and 'corredora' */}
                <Paragraph strong>Facultados para firmar</Paragraph>
                <Form.List name="empoweredToSign">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                        <Row key={key} gutter={tokens.forms.horizontalGutterInPx}>
                          <Col span={24}>{index > 0 && <Divider style={{ marginTop: 0 }} />}</Col>
                          <AloneCol span={12}>
                            <Form.Item
                              {...restField}
                              name={[name, 'name']}
                              fieldKey={[fieldKey, 'name']}
                              rules={[{ required: true }]}
                              label="Nombre Completo"
                            >
                              <Input />
                            </Form.Item>
                          </AloneCol>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              name={[name, 'firstSurname']}
                              fieldKey={[fieldKey, 'firstSurname']}
                              label="Apellido Paterno"
                              rules={[{ required: true }]}
                            >
                              <Input type="text" maxLength={25} />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              name={[name, 'secondSurname']}
                              fieldKey={[fieldKey, 'secondSurname']}
                              label="Apellido Materno"
                              rules={[{ required: false }]}
                            >
                              <Input type="text" maxLength={25} />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              name={[name, 'identificationType']}
                              fieldKey={[fieldKey, 'identificationType']}
                              label="Tipo de identificación"
                              rules={[{ required: true }]}
                              onChange={handleEmpoweredToSignIdTypeChange(name)}
                            >
                              <Radio.Group>
                                <Radio value={IdentificationType.RUT}>RUT</Radio>
                                <Radio value={IdentificationType.PASAPORTE}>Pasaporte</Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              label={getEmpoweredToSignIdLabel(name)}
                              name={[name, 'identification']}
                              fieldKey={[fieldKey, 'identification']}
                              rules={[
                                {
                                  required: true,
                                  min:
                                    empoweredToSignIdTypes[name] === IdentificationType.RUT
                                      ? 11
                                      : 6,
                                  validator:
                                    empoweredToSignIdTypes[name] === IdentificationType.RUT
                                      ? rutValidator
                                      : undefined,
                                },
                              ]}
                            >
                              {empoweredToSignIdTypes[name] === IdentificationType.RUT ? (
                                <InputRut maxLength={12} />
                              ) : (
                                <Input maxLength={24} disabled={!empoweredToSignIdTypes[name]} />
                              )}
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              label="E-mail"
                              name={[name, 'email']}
                              fieldKey={[fieldKey, 'email']}
                              rules={[{ required: true, type: 'email' }]}
                            >
                              <Input type="email" />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              name={[name, 'emailValidation']}
                              fieldKey={[fieldKey, 'emailValidation']}
                              label="Reescriba su E-mail"
                              validateTrigger="onBlur"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (
                                      value !==
                                      complementaryForm.getFieldValue([
                                        'empoweredToSign',
                                        name,
                                        'email',
                                      ])
                                    ) {
                                      return Promise.reject(new Error('Los correos no coinciden.'));
                                    }
                                    return Promise.resolve();
                                  },
                                  type: 'email',
                                },
                              ]}
                            >
                              <Input
                                type="email"
                                maxLength={64}
                                onPaste={preventCopyPasteAndSpaces}
                                onInput={preventCopyPasteAndSpaces}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              label="Teléfono móvil"
                              name={[name, 'phone']}
                              fieldKey={[fieldKey, 'phone']}
                              rules={[
                                {
                                  required: true,
                                  len: 9,
                                },
                              ]}
                              normalize={form.normalizers.numeric}
                            >
                              <Input maxLength={9} />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              label={
                                <span style={{ marginBottom: '2px' }}>
                                  Teléfono fijo (opcional)
                                </span>
                              }
                              name={[name, 'phoneAlt']}
                              fieldKey={[fieldKey, 'phoneAlt']}
                              rules={[
                                {
                                  len: 9,
                                },
                              ]}
                              normalize={form.normalizers.numeric}
                            >
                              <Input maxLength={9} />
                            </Form.Item>
                          </Col>
                          <AloneCol span={12}>
                            <Form.Item
                              {...restField}
                              label="Fecha de nacimiento"
                              name={[name, 'dateOfBirth']}
                              fieldKey={[fieldKey, 'dateOfBirth']}
                              rules={[{ required: true }]}
                            >
                              <DatePicker
                                defaultPickerValue={form.date.defaultValue.yearsAgo(30)}
                                showToday={false}
                                disabledDate={form.date.dateDisablers.minAge(10)}
                                format={form.date.format.day}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                          </AloneCol>
                          <AloneCol span={12}>
                            <Form.Item
                              {...restField}
                              label="Sexo"
                              name={[name, 'sex']}
                              fieldKey={[fieldKey, 'sex']}
                              rules={[{ required: true }]}
                            >
                              <Select placeholder="Seleccione una opción" loading={areSexesLoading}>
                                {sexes.map((sex) => (
                                  <Select.Option key={sex.id} value={sex.id}>
                                    {sex.name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </AloneCol>
                          <AloneCol span={12}>
                            <Form.Item
                              {...restField}
                              name={[name, 'country']}
                              fieldKey={[fieldKey, 'country']}
                              rules={[{ required: true }]}
                              label="País"
                            >
                              <Select
                                loading={areCountriesLoading}
                                placeholder="Seleccione una opción"
                              >
                                {countries.map((country) => (
                                  <Select.Option key={country.id} value={country.id}>
                                    {country.name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </AloneCol>
                          <Col span={24}>
                            <Form.Item
                              {...restField}
                              label="Nombre del cargo"
                              name={[name, 'position']}
                              fieldKey={[fieldKey, 'position']}
                              rules={[{ required: true }]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="Poder notarial"
                              name={[name, 'power']}
                              rules={[{ required: true }]}
                            >
                              <FileSelect
                                accept={'image/*,.pdf'}
                                maxSizeKb={10240}
                                defaultFileList={powerFileLists[index]}
                                onFileListChange={handlePowerFileListChange(index)}
                              >
                                Subir poder notarial
                              </FileSelect>
                            </Form.Item>
                          </Col>
                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => {
                                remove(name);
                                handleEmpoweredToSignRemove(index);
                              }}
                              icon={<MinusOutlined />}
                            >
                              Eliminar Persona
                            </Button>
                          </Form.Item>
                        </Row>
                      ))}
                      {fields.length < 3 && (
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => {
                              add();
                              handleEmpoweredToSignAdd(fields.length);
                            }}
                            block
                            icon={<PlusOutlined />}
                          >
                            Agregar persona
                          </Button>
                        </Form.Item>
                      )}
                    </>
                  )}
                </Form.List>
                <Form.Item>
                  <Row>
                    <Col lg={19} xs={23}>
                      <Form.Item
                        label="¿Autoriza la reinversión de los beneficios repartidos en cuotas del Fondo o de la serie respectiva? (Sólo para Vantrust Capital Administradora General de Fondos SA y Vantrust Gestión Patrimonial SA)"
                        name={['authorizeReinvestment']}
                        rules={[{ required: true }]}
                      >
                        <Radio.Group
                          options={[
                            { label: 'Si', value: true },
                            { label: 'No', value: false },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={19} xs={23}>
                      <Form.Item
                        label="¿Eres un inversionista calificado?"
                        name={['enrollmentInvestorProfile', 'isQualifiedInvestor']}
                        rules={[{ required: true }]}
                      >
                        <Radio.Group
                          options={[
                            { label: 'Si', value: true },
                            { label: 'No', value: false },
                          ]}
                          onChange={onChangeRadioQualified}
                        />
                      </Form.Item>
                      <DrawerQualifiedProfile
                        visible={visible}
                        closeDrawer={() => setVisible(false)}
                        form={qualifiedInfoForm}
                        qualifiedInvestor={qualifiedInvestor}
                        setSavedQualifiedInvestor={setSavedQualifiedInvestor}
                        showValidationMessages={showValidationMessages}
                      />
                    </Col>
                  </Row>
                  <Form.Item
                    name={['person', 'isUsPerson']}
                    label={
                      <Row gutter={8}>
                        <Col>¿Eres ciudadano/residente de E.E.U.U?</Col>
                        <Col>
                          <FatcaModal />
                        </Col>
                      </Row>
                    }
                    rules={[{ required: true }]}
                    style={{ margin: 0 }}
                    onChange={handleUsPersonChange}
                  >
                    <Radio.Group>
                      <Radio value>Sí</Radio>
                      <Radio value={false}>No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Form.Item>
              </Col>
              {showsNif && (
                <Col span={12}>
                  <Form.Item
                    name={['person', 'nif']}
                    label="N° NIF"
                    rules={[{ required: true }]}
                    normalize={form.normalizers.numeric}
                  >
                    <Input maxLength={10} />
                  </Form.Item>
                </Col>
              )}
              <Col span={24}>
                <Form.Item>
                  <Form.Item
                    name="hasForeignTaxResidences"
                    label="¿Tienes Residencia Tributaria distinta o adicional a la chilena?"
                    rules={[{ required: true }]}
                    style={{ margin: 0 }}
                    onChange={handleHasTaxResidenceChange}
                  >
                    <Radio.Group>
                      <Radio value>Sí</Radio>
                      <Radio value={false}>No</Radio>
                    </Radio.Group>
                  </Form.Item>
                  <TaxResidenceModal />
                </Form.Item>
              </Col>
              {showsTaxResidences && (
                <>
                  <Col span={12}>
                    <Form.Item
                      name={['person', 'placeOfBirth']}
                      label="Lugar de nacimiento"
                      rules={[{ required: true }]}
                    >
                      <Select placeholder="Seleccionar">
                        {countries.map(({ name, id }) => (
                          <Select.Option key={id} value={id}>
                            {name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.List
                      name="foreignTaxResidences"
                      initialValue={initialValues?.foreignTaxResidences ? undefined : [{}]}
                    >
                      {(fields, { add, remove }) => (
                        <Row gutter={tokens.forms.horizontalGutterInPx}>
                          {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                            <React.Fragment key={key}>
                              <Col span={12}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'country']}
                                  fieldKey={[fieldKey, 'country']}
                                  rules={[{ required: true }]}
                                  label={index === 0 ? 'País de Residencia Tributaria' : undefined}
                                >
                                  <Select
                                    loading={areCountriesLoading}
                                    placeholder="País de Residencia Tributaria"
                                  >
                                    {countries.map((country) => (
                                      <Select.Option key={country.id} value={country.id}>
                                        {country.name}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'tin']}
                                  fieldKey={[fieldKey, 'tin']}
                                  label={index === 0 ? 'N° Identificación Tributaria' : undefined}
                                  normalize={form.normalizers.alphanumericUpperCase}
                                  rules={[{ required: true }]}
                                >
                                  <Input
                                    placeholder="N° Identificación Tributaria"
                                    maxLength={19}
                                  />
                                </Form.Item>
                              </Col>
                            </React.Fragment>
                          ))}
                          <Col span={12}>
                            {fields.length < 3 && (
                              <Form.Item>
                                <Button
                                  type="dashed"
                                  onClick={() => add()}
                                  block
                                  icon={<PlusOutlined />}
                                >
                                  Agregar residencia
                                </Button>
                              </Form.Item>
                            )}
                          </Col>
                          {fields.length > 1 && (
                            <Col span={12}>
                              <Form.Item>
                                <Button
                                  type="dashed"
                                  onClick={() => remove(fields.length - 1)}
                                  icon={<MinusOutlined />}
                                  block
                                >
                                  Eliminar residencia
                                </Button>
                              </Form.Item>
                            </Col>
                          )}
                        </Row>
                      )}
                    </Form.List>
                  </Col>
                </>
              )}
              <Col span={24}>
                <Form.Item
                  name="acceptsFundsOriginTerms"
                  rules={[{ required: true }]}
                  valuePropName="checked"
                  normalize={form.normalizers.requiredCheckbox}
                >
                  <Checkbox>
                    He leído y acepto la
                    <FundsOriginDeclarationModal />.
                  </Checkbox>
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" block>
                    Siguiente
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Spin>
  );
};

ComplementaryInfoStep.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default ComplementaryInfoStep;
